
const About = () => {
  const stats = [
    { number: '500+', label: 'Erfolgreiche Projekte' },
    { number: '50+', label: 'Zufriedene Kunden' },
    { number: '5+', label: 'Jahre Erfahrung' },
    { number: '24/7', label: 'Notfall-Bereitschaft' }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h3 className="text-4xl font-bold text-gray-900 mb-6">
              Über <strong>AEROSCAN360</strong>
            </h3>
            <p className="text-xl text-gray-600 mb-8">
              Als führender Anbieter für professionelle Drohnen-Dienstleistungen in Deutschland 
              kombinieren wir modernste Technologie mit jahrelanger Erfahrung. Unser Fokus liegt 
              auf präzisen Vermessungen, zuverlässigen Inspektionen und schnellen Rettungsaktionen.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Zertifizierte Expertise</h4>
                  <p className="text-gray-600">
                    Alle unsere Piloten verfügen über die erforderlichen Lizenzen und Zertifizierungen 
                    für den gewerblichen Drohneneinsatz in Deutschland.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-settings-3-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Modernste Technologie</h4>
                  <p className="text-gray-600">
                    Wir setzen auf hochpräzise Drohnensysteme mit modernster Sensor- und 
                    Kameratechnologie für optimale Ergebnisse.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-time-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Schnelle Reaktionszeit</h4>
                  <p className="text-gray-600">
                    Bei Notfällen und dringenden Projekten sind wir innerhalb kürzester Zeit 
                    einsatzbereit - 24 Stunden am Tag, 7 Tage die Woche.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/d6212764e2e22a594116bb5aaa2c701d/ba9e6b9cd2e222b6bebe9426d2ffc87c.png"
              alt="Professionelle Drohnen-Dienstleistungen von Aeroscan360"
              title="Aeroscan360 Drohnen-Dienstleistungen Deutschland"
              className="rounded-2xl shadow-2xl object-cover w-full h-[500px] object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
